import * as Phaser from 'phaser';
import { PaintedScene } from '../PaintedScene';
import {
  installSnowTexture,
  installBreathTexture,
  createSnowfall,
  createBreathMist,
} from './frostmereAmbient';

export const WAKE_NOT_YET_CAIRN_PHASER_KEY = 'WakeNotYetCairnScene' as const;
export const WAKE_NOT_YET_CAIRN_MANIFEST_KEY = 's-304-wake-not-yet-cairn' as const;

const COLOR_GRADE_TINT = 0xb8c8e0;

export class WakeNotYetCairnScene extends PaintedScene {
  private snowEmitter: Phaser.GameObjects.Particles.ParticleEmitter | null = null;
  private breathEmitter: Phaser.GameObjects.Particles.ParticleEmitter | null = null;
  private colorGradeOverlay: Phaser.GameObjects.Rectangle | null = null;

  constructor() {
    super(WAKE_NOT_YET_CAIRN_PHASER_KEY, WAKE_NOT_YET_CAIRN_MANIFEST_KEY);
  }

  preload(): void {
    super.preload();
    installSnowTexture(this);
    installBreathTexture(this);
  }

  protected override onSceneReady(): void {
    this.buildColorGradeOverlay();
    // Preternatural stillness: snow falls straight down, very slow — no wind drift
    this.snowEmitter = createSnowfall(this, 0.4);
    if (this.snowEmitter) {
      this.snowEmitter.speedX = { min: -2, max: 2 };
      this.snowEmitter.speedY = { min: 10, max: 25 };
    }

    if (this.walker) {
      this.breathEmitter = createBreathMist(this, this.walker);
    }
  }

  protected override onSceneShutdown(): void {
    this.snowEmitter?.destroy();
    this.breathEmitter?.destroy();
    this.colorGradeOverlay?.destroy();
    this.snowEmitter = null;
    this.breathEmitter = null;
    this.colorGradeOverlay = null;
  }

  private buildColorGradeOverlay(): void {
    const w = this.scale.width;
    const h = this.scale.height;
    this.colorGradeOverlay = this.add.rectangle(w / 2, h / 2, w, h, COLOR_GRADE_TINT, 0.06);
    this.colorGradeOverlay.setScrollFactor(0);
    this.colorGradeOverlay.setDepth(140);
    this.colorGradeOverlay.setBlendMode(Phaser.BlendModes.MULTIPLY);
  }
}
